import { datadogRum } from '@datadog/browser-rum';
import { environment } from 'environments/environment';

if (
  environment.DATADOG_APPLICATION_ID && environment.DATADOG_CLIENT_TOKEN
) {
  datadogRum.init({
    applicationId: environment.DATADOG_APPLICATION_ID,
    clientToken: environment.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'pipeline',
    env: 'production',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: false,
    trackLongTasks: false,
    defaultPrivacyLevel: 'mask-user-input'
  });
}
